import * as types from 'src/store/types';
import Vue from 'vue'
import {router} from 'src/main'
import app from 'src/main'
import _ from 'lodash'
export default {
  update({commit, dispatch, state, rootState}) {
    const brandId = rootState.brands.current
    if (brandId) {
      Vue.axios
        .get(`expostat/brand/${brandId}/events/`)
        .then(r => r.data)
        .then(events => {
          commit('updateAvailableEvents', events)
          if (state.current !== null && !events.find(o => o.id === state.current)) {
            commit('resetCurrent')
          }
          if ((state.current === null || state.currentEventInfo === null) && events.length > 0) {
            commit('changeCurrent', events[0])
          }
        })
    }

    // debugger
  },
  async changeCurrent (context, payload) {
    if (context.state.current !== payload) {
      try {
        const result = await Vue.axios.get(`expostat/event/${payload}/`)
        const eventInfo = result.data
        context.commit('changeCurrent', eventInfo)
      } catch (error) {
        console.error(error)
        debugger
      }
    }
  },
  resetCurrent ({commit}) {
    commit('resetCurrent')
  },
  updateEventInfo(context, payload) {
    // console.log(router)
    // window.router = router
    // app.$root.eventInfo = this.getters["events/currentEventInfo"]
    if (router.app.$route.params && router.app.$route.params.eventUri) {
      let route = {
        name: router.app.$route.name,
        // replace: true,
        params: _.cloneDeep(router.app.$route.params)
      }
      route.params.eventUri = context.state.currentEventInfo.uri
      // let url = router.app.$route.fullPath.replace(`/event/${router.app.$route.params.eventUri}`, `/event/${route.params.eventUri}`)
      let url = router.app.$router.resolve(route).href
      router.app.$router.push(url)
      // router.app.$router.push(route)
    }
  },
  async changeEventByUri(context, payload) {
    if (context.state.currentEventInfo === null || context.state.currentEventInfo.uri !== payload) {
      try {
        const result = await Vue.axios.get('expostat/event/by-uri/', { params:{uri: payload} })
        const eventInfo = result.data
        context.commit('changeCurrent', eventInfo)
      } catch (error) {
        console.error(error)
        debugger
      }
    }
  }
};
